module.exports = __webpack_public_path__ + "static/media/KWPPA_logo.210e89af.png";